export default "__VITE_ASSET__Duwg71ts__"